/**
 * RepProfile Service
 * Register Angular Services for RepProfile
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('RepProfile', ['$resource', function($resource){
    return $resource('/api/v2/field/:id');
}]);
